import { useState } from 'react';
import Lottie from 'lottie-react';
import RegistrationSuccess from '../../Components/Animations/RegistrationSuccess';
import virtualBoxAnimation from '../../../../animations/virtual-box.json';

import './PostRegistrationVirtualBox.scss';
import ReadyToShip from '../PostRegistration/ReadyToShip';

export default function PostRegistrationVirtualBox({
  storeConfig,
  stepTrackerProps,
  onClick,
  showSuccessAnimation,
  shippingMethod,
  address,
}) {
  const [showRegistrationSuccess, setShowRegistrationSuccess] = useState(showSuccessAnimation);

  if (showRegistrationSuccess && storeConfig.isTrashie) {
    return (
      <RegistrationSuccess
        isVirtualBox
        onShowingAnimation={setShowRegistrationSuccess}
      />
    );
  }

  return (
    <div className="PostRegistrationVirtualBox">
      <div className="PostRegistrationVirtualBox__container">
        <div className="PostRegistrationVirtualBox__header">
          <div className="PostRegistrationVirtualBox__header--title">
            CONGRATS!
          </div>
          <div className="PostRegistrationVirtualBox__header--message">
            Sick move! You just sent waste packing and kept a heap of goodies out of the dump.
            Trashie loves you for it.
          </div>
        </div>

        <div className="PostRegistrationVirtualBox__actions">
          <div className="PostRegistrationVirtualBox__actions--title">
            WHAT&apos;S NEXT?
          </div>

          <div className="PostRegistrationVirtualBox__actions--buttons">
            <ReadyToShip
              onClick={onClick}
              shippingMethod={shippingMethod}
              address={address}
              storeConfig={storeConfig}
              stepTrackerProps={stepTrackerProps}
              isVirtualBox
            />
          </div>
        </div>

        <div className="PostRegistrationVirtualBox__guidelines">
          <div className="PostRegistrationVirtualBox__guidelines--title">
            BOX GUIDELINES
          </div>
          <div className="PostRegistrationVirtualBox__guidelines--content">
            <div className="PostRegistrationVirtualBox__guidelines--text">
              Follow the guidelines below to ensure your box ships safely and your unwanted tech
              stays out of landfill
            </div>
            <div className="ReuseBox__container--image--background">
              <div className="ReuseBox__container--image--box">
                <Lottie
                  animationData={virtualBoxAnimation}
                  loop
                  autoplay
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
